<template>
  <div id="app">
    <pc-header-menu v-if="this.$isPC" />
    <sp-header-menu v-else />
    <router-view id="wrapper" :class="this.$isPC ? '' : 'sp-wrapper-margin'" />
    <footer-menu />
    <div class="fixed-cta-bar">
      <p class="fixed-cta-bar__text">
        <svg class="fixed-cta-bar__icon" aria-hidden="true" viewBox="0 0 24 24">
          <path
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
          ></path>
        </svg>
        お問い合わせ・デモ機のご相談など<span class="fixed-cta-bar__text-sub"
          >お急ぎの方はお電話で</span
        >
      </p>
      <div class="fixed-cta-bar__buttons">
        <router-link
          to="/contact"
          class="fixed-cta-bar__btn fixed-cta-bar__btn--contact"
        >
          <svg aria-hidden="true" viewBox="0 0 24 24">
            <path
              d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
            ></path>
          </svg>
          無料見積もり・お問い合わせ
        </router-link>
        <span class="fixed-cta-bar__divider"></span>
        <a
          href="tel:076-294-4440"
          class="fixed-cta-bar__btn fixed-cta-bar__btn--tel"
        >
          <svg aria-hidden="true" viewBox="0 0 24 24">
            <path
              d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99"
            ></path>
          </svg>
          076-294-4440
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import vueSmoothScroll from 'vue-smooth-scroll'
import PcHeaderMenu from '@/components/modules/PcHeaderMenu'
import SpHeaderMenu from '@/components/modules/SpHeaderMenu'
import FooterMenu from '@/components/modules/FooterMenu'
import LinkButton from '@/components/modules/LinkButton'
import { Slide } from 'vue-burger-menu'

Vue.use(vueSmoothScroll)
Vue.component('link-button', LinkButton)
Vue.component('slide', Slide)

Vue.prototype.$isPC = screen.width >= 1100

Vue.filter('toLocaleString', function(value) {
  return value.toLocaleString()
})

export default {
  name: 'App',
  components: {
    PcHeaderMenu,
    SpHeaderMenu,
    FooterMenu,
  },
}
</script>

<style>
body {
  margin: auto;
}

#app {
  font-family: 'ヒラギノ角ゴ Pro W3', 'Hiragino Kaku Gothic Pro', '游ゴシック体',
    'メイリオ', Meiryo, 'Yu Gothic', YuGothic, 'Oswald', 'ＭＳ Ｐゴシック',
    sans-serif;

  color: #4d4d4d;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app :lang(en) {
  font-family: Arial, Helvetica, 'sans-serif';
}

#wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;

  width: auto;
}

.sp-wrapper-margin {
  margin-top: 96px;
}

/* 汎用テーブル */
.common-table {
  font-size: 14px;

  display: flex;
  justify-content: center;

  width: 100%;

  border-collapse: collapse;
}

.common-table th {
  font-weight: normal;

  width: 200px;
  padding: 5px;

  text-align: center;

  border: 1px solid rgb(208, 209, 210);
  background-color: rgb(238, 244, 249);
}

.common-table td {
  width: 700px;
  padding: 10px 20px 10px;

  text-align: left;

  border: 1px solid rgb(208, 209, 210);
}

/* 商品タイプの表示 */
.product-type {
  display: flex;
}

.product-type section {
  flex-basis: 100%;
  flex-grow: 1;

  padding: 0;
}

.product-items {
  width: 455px;
  margin: 0;
  padding: 10px 0 10px;

  list-style: none;
}

.product-items li + li {
  margin-top: 10px;
}

.for-outgoing,
.for-incoming {
  padding: 2%;
}

.product-header {
  font-weight: bold;

  display: inline-block;

  width: 90%;
  padding: 10px 5%;

  text-align: center;
}

.product-header .header-bold {
  font-size: 30px;
}

.product-items li {
  text-align: left;
}

.product-items li .summary-appeal {
  margin: 10px 0;

  white-space: pre-line;
}

.product-items li .summary-detail {
  margin-bottom: 10px;

  white-space: pre-line;
}

/* for-outgoing */
.for-outgoing {
  margin: 0 10px 0 0;

  background-color: rgb(232, 248, 237);
}

.for-outgoing .product-header {
  float: right;

  /* padding-right: 100px;
  padding-left: 50%; */

  background-color: rgb(190, 234, 203);
}

.for-outgoing .product-header .header-bold {
  color: rgb(45, 183, 68);
}

.for-outgoing .product-items {
  float: right;

  padding-right: 25px;
  padding-left: 15px;
}

.for-outgoing .product-items li .summary-appeal {
  color: rgb(45, 183, 68);
}

.for-outgoing .product-items li .summary-footer a {
  color: rgb(45, 183, 68);
  border: 1px solid rgb(45, 183, 68);
  background-color: rgb(248, 252, 249);
}

/* for-incoming */
.for-incoming {
  background: rgb(233, 245, 255);
}

.for-incoming .product-header {
  float: left;

  /* padding-right: 50%;
  padding-left: 100px; */

  background-color: rgb(167, 214, 253);
}

.for-incoming .product-header .header-bold {
  color: rgb(16, 106, 203);
}

.for-incoming .product-items {
  float: left;

  padding-right: 15px;
  padding-left: 25px;
}

.for-incoming .product-items li .summary-appeal {
  color: rgb(16, 106, 203);
}

.for-incoming .product-items li .summary-footer a {
  color: rgb(16, 106, 203);
  border: 1px solid rgb(16, 106, 203);
  background-color: rgb(248, 251, 255);
}

/* 汎用リンクボタン */
.link-button {
  font-size: 14px;
  font-weight: bold;
  line-height: 16px;

  float: right;

  min-width: 120px;
  padding: 5px;

  text-align: center;
  text-decoration: none;

  color: white;
  border-radius: 3px;
  background-color: rgb(26, 87, 167);
  transition: opacity 0.3s;
}

.link-button:hover {
  opacity: 0.6;
}

/* サークルヘッダー */
.circle-parent {
  position: relative;

  width: auto;
  height: 60px;
}

.circle-heading {
  position: relative;
  z-index: 1;

  display: inline-block;

  width: 150px;
  height: 150px;

  border-radius: 50%;
  background: rgb(26, 87, 167);
}

.circle-heading.green {
  background: rgb(45, 183, 68);
}

.circle-heading-title {
  font-size: 18px;
  font-weight: bold;

  position: absolute;
  top: 50%;
  left: 0;

  width: 100%;

  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  text-align: center;

  color: white;

  margin: 0;
}

/* 固定CTAバー */
body {
  padding-bottom: 64px;
}

.fixed-cta-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;

  padding: 12px 28px;

  background: linear-gradient(180deg, #ffffff 0%, #f8fafe 100%);
  border-top: 3px solid rgb(26, 87, 167);
  box-shadow: 0 -3px 16px rgba(0, 0, 0, 0.1);
}

.fixed-cta-bar__icon {
  width: 18px;
  height: 18px;
  fill: rgb(26, 87, 167);
  vertical-align: -3px;
  margin-right: 4px;
}

.fixed-cta-bar__text {
  font-size: 13px;
  line-height: 1.4;

  margin: 0;

  color: #333;
  white-space: nowrap;
  letter-spacing: 0.5px;
}

.fixed-cta-bar__text-sub {
  display: inline;
  margin-left: 6px;
  color: #e60044;
  font-weight: bold;
}

.fixed-cta-bar__buttons {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-shrink: 0;
}

.fixed-cta-bar__divider {
  width: 1px;
  height: 28px;
  background: #ccc;
}

.fixed-cta-bar__btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;

  padding: 10px 22px;

  font-size: 13px;
  font-weight: bold;
  line-height: 1;
  white-space: nowrap;
  text-decoration: none;

  border-radius: 4px;
  transition: opacity 0.3s;
}

.fixed-cta-bar__btn--contact {
  color: white;
  background: rgb(26, 87, 167);
  border-bottom: 3px solid rgb(15, 58, 120);
  box-shadow: 0 2px 8px rgba(26, 87, 167, 0.25);
}

.fixed-cta-bar__btn--contact svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  fill: white;
}

.fixed-cta-bar__btn--tel {
  color: #e60044;
  border: 2px solid #e60044;
  border-bottom: 3px solid #c0003a;
  background: white;
  box-shadow: 0 2px 8px rgba(230, 0, 68, 0.12);
}

.fixed-cta-bar__btn--tel svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  fill: #e60044;
}

.fixed-cta-bar__btn:hover {
  opacity: 0.7;
}

@media only screen and (max-width: 1099px) {
  body {
    padding-bottom: 0;
  }

  .fixed-cta-bar {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue